import { render, staticRenderFns } from "./modal-v2.vue?vue&type=template&id=5467b740&scoped=true&"
import script from "./modal-v2.vue?vue&type=script&lang=ts&"
export * from "./modal-v2.vue?vue&type=script&lang=ts&"
import style0 from "./modal-v2.vue?vue&type=style&index=0&id=5467b740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467b740",
  null
  
)

export default component.exports